<template>
  <app>
    <NuxtPage />
  </app>
</template>
